export const plainText = (html = "") => {
  const document = new DOMParser().parseFromString(html || "", "text/html");
  document
    .querySelectorAll("script,style,iframe,video")
    .forEach((node) => node.remove());
  document
    .querySelectorAll("p,div,li,h1,h2,h3,h4,h5,h6,br,td,th")
    .forEach((node) => node.append(" "));
  return (document.body.textContent || "").replace(/\s+/g, " ").trim();
};

export const makeSlug = (title = "") =>
  title
    .trim()
    .toLowerCase()
    .replace(/[\s\u200c]+/g, "-")
    .replace(/[^\p{L}\p{N}-]/gu, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");

export function inspectArticle(article) {
  const document = new DOMParser().parseFromString(
    article.newsText || "",
    "text/html",
  );
  const words = plainText(article.newsText).split(/\s+/).filter(Boolean).length;
  const headings = [...document.querySelectorAll("h1,h2,h3,h4,h5,h6")].map(
    (node) => ({ level: Number(node.tagName[1]), text: node.textContent }),
  );
  const images = [...document.querySelectorAll("img")];
  const checks = [
    {
      ok: Boolean(article.articleTittle?.trim()),
      label: "عنوان روشن و اختصاصی مقاله",
    },
    {
      ok: Boolean(article.slug?.trim()) && !/[\s/?#]/.test(article.slug),
      label: "نامک خوانا و بدون فاصله",
    },
    {
      ok: Boolean(plainText(article.newsBox)),
      label: "خلاصه اختصاصی برای توضیحات نتایج جستجو",
    },
    { ok: Boolean(article.mainPicture), label: "تصویر شاخص مقاله" },
    { ok: words > 0, label: "متن اصلی مقاله" },
    {
      ok: headings.some((heading) => heading.level === 2),
      label: "تقسیم متن با تیترهای H2",
    },
    {
      ok: !headings.some((heading) => heading.level === 1),
      label: "عنوان اصلی فقط در بالای مقاله؛ بدون H1 تکراری در متن",
    },
    {
      ok: images.every((image) => image.getAttribute("alt")?.trim()),
      label: "توضیح جایگزین برای تصاویر داخل متن",
    },
    {
      ok: !headings.some(
        (heading, index) =>
          heading.level > (index ? headings[index - 1].level : 1) + 1,
      ),
      label: "ترتیب منطقی تیترها بدون پرش سطح",
    },
  ];
  return {
    words,
    minutes: Math.max(1, Math.ceil(words / 200)),
    headings,
    checks,
    complete: checks.filter((check) => check.ok).length,
  };
}

export function articlePayload(article, categories, tags, datePublished) {
  return {
    ArticleId: article.articleId,
    ArticleTittle: article.articleTittle.trim(),
    ArticleTittleEn: article.articleTittleEn || null,
    Slug: article.slug.trim(),
    SlugEn: article.slugEn || null,
    SecondTitle: article.secondTitle || "",
    SecondTitleEn: article.secondTitleEn || null,
    NewsBox: article.newsBox || "",
    NewsBoxEn: article.newsBoxEn || null,
    NewsText: article.newsText,
    NewsTextEn: article.newsTextEn || null,
    MainPicture: article.mainPicture,
    Categories: categories.map((item) => item.value).join(","),
    Tags: tags.map((item) => item.value).join(","),
    MainPage: Boolean(article.mainPage),
    IsLast: Boolean(article.isLast),
    IsProminent: Boolean(article.isProminent),
    IsMostViewed: Boolean(article.isMostViewed),
    DatePublished: datePublished,
  };
}

export function csvCell(value) {
  let text = String(value ?? "");
  if (/^[\s]*[=+\-@]/.test(text)) text = "'" + text;
  return '"' + text.replace(/"/g, '""') + '"';
}
